import {Component, Inject, OnInit, QueryList, ViewChildren} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {SingleQuestionComponent} from '../../components/surveys/single-question/single-question.component';
import {SurveyService} from '../../services/surveys.service';
import {TranslateService} from '@ngx-translate/core';
import {ToastService} from '../../services/general/toast.service';

@Component({
  selector: 'app-modal-split-question',
  templateUrl: './modal-split-question.component.html',
  styleUrls: ['./modal-split-question.component.scss'],
  standalone: false
})
export class ModalSplitQuestionComponent implements OnInit {
  @ViewChildren(SingleQuestionComponent) questionComponents!: QueryList<SingleQuestionComponent>;

  originalQuestion: any;
  newQuestions: any[] = [];
  questionIdCounter = 1;

  constructor(
    public dialogRef: MatDialogRef<ModalSplitQuestionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private surveyService: SurveyService,
    private translateService: TranslateService,
    private toast: ToastService
  ) {
    this.originalQuestion = data.question;
  }

  ngOnInit(): void {
    if (this.originalQuestion?.customs?.split_questions) {
      this.newQuestions = this.originalQuestion.customs.split_questions;
      this.questionIdCounter = this.newQuestions.length + 1;
      return;
    }
    this.addQuestion('1° Split');
    this.addQuestion('2° Split');

    // Pre-fill the splits with the statements produced by the AI rewriting
    // pipeline, one statement per split.
    const statements: string[] = Array.isArray(this.data?.statements) ? this.data.statements : [];
    if (statements.length > 0) {
      this.prefillSplits(statements);
    } else if (this.data?.rewritten_statement) {
      this.newQuestions[0].question = this.data.rewritten_statement;
    }
  }

  private prefillSplits(statements: string[]): void {
    // Ensure there are enough split slots for every returned statement.
    while (this.newQuestions.length < statements.length) {
      this.addQuestion(`${this.newQuestions.length + 1}° Split`);
    }
    statements.forEach((statement, i) => {
      this.newQuestions[i].question = statement;
    });
  }

  addQuestion(name?: string) {
    this.newQuestions.push({
      id: this.questionIdCounter++,
      question: name,
      required: true,
      typology: this.originalQuestion.typology,
      choices: [],
      description: '',
      attachments: [],
      response: {customs: {}, attachments: []},
      customs: {...this.originalQuestion.customs},
      is_new: true
    });
  }

  removeQuestion(index: number) {
    if (this.newQuestions.length > 2) {
      this.newQuestions.splice(index, 1);
    }
  }

  // cancelDecision() {
  //   this.originalQuestion.final_decision = null;
  //   this.dialogRef.close({cancelled: true});
  // }

  save() {
    // Basic validation
    if (this.newQuestions.some(q => !q.question)) {
      this.toast.error(
        this.translateService.instant('generic.error'),
        this.translateService.instant('modals.modal-survey-details.errors.title-is-required')
      );
      return;
    }

    this.dialogRef.close(this.newQuestions);
  }

  close() {
    this.dialogRef.close();
  }
}
